// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as StringUtils$Showside from "../../utils/StringUtils.bs.js";
import * as CustomScript$Showside from "../../utils/CustomScript.bs.js";
import * as RouterProvider$Showside from "../../context/RouterProvider.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function noneIfEmpty(a) {
  if (a.length === 0) {
    return;
  } else {
    return a;
  }
}
function useItems(root, param) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var config = match$1.config;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var isNested = function (category) {
    return Belt_Option.mapWithDefault(root, false, function (root) {
      return !Belt_Array.some(Category$Showside.getChildren(root), function (c) {
        return c.id === category.id;
      });
    });
  };
  var categories = React.useMemo(function () {
    return Belt_Array.keep(Belt_Array.concat(Belt_Option.mapWithDefault(root, [], function (root) {
      var newrecord = Caml_obj.obj_dup(root);
      return [(newrecord.title = StringUtils$Showside.concatWithoutRepeat("All", root.title), newrecord)];
    }), Belt_Option.getWithDefault(Belt_Option.map(root, function (root) {
      return Belt_Array.concatMany(Belt_Array.map(Category$Showside.getChildren(root), function (category) {
        if (ctx.threeColumnLayout) {
          return [category];
        } else {
          return Belt_Array.concat([category], Category$Showside.getChildren(category));
        }
      }));
    }), config.categories)), function (category) {
      if (Category$Showside.isIndexNode(category)) {
        return ctx.isIndexAllowed;
      } else {
        return true;
      }
    });
  }, [root, config.lastModifiedAt, ctx.mode]);
  var pathMap = React.useMemo(function () {
    return Js_dict.fromArray(Belt_Array.map(categories, function (category) {
      return [category.id, Category$Showside.getCategoryPathById(config.categories, category.id)];
    }));
  }, [categories]);
  return React.useMemo(function () {
    return Belt_Option.keep(Belt_Array.map(categories, function (category) {
      var selfPath = Belt_Option.getWithDefault(Js_dict.get(pathMap, category.id), []);
      var parent = Belt_Array.get(Belt_Array.reverse(selfPath), 1);
      var match = Category$Showside.Link.getCardLink(category);
      var link;
      if (match !== undefined) {
        switch (match.TAG | 0) {
          case /* URL */0:
            link = Category$Showside.hasAnyItems(category) ? /* NoLink */0 : {
              TAG: /* ExternalLink */1,
              _0: {
                href: match._0,
                label: category.title,
                openInNewTab: config.settings.openLinkInNewTab,
                category: category
              }
            };
            break;
          case /* Product */2:
            var match$1 = match._0;
            var variantId = match$1.variantId;
            var productId = match$1.productId;
            link = {
              TAG: /* InternalLink */0,
              _0: function (e) {
                Curry._3(goTo, undefined, undefined, {
                  TAG: /* PDP */2,
                  _0: {
                    categoryId: undefined,
                    productCategoryId: undefined,
                    productId: productId,
                    variantId: variantId,
                    zoomedPhotoIndex: undefined
                  }
                });
              }
            };
            break;
          case /* Category */1:
          case /* StoreCategory */3:
            link = /* NoLink */0;
            break;
          case /* CustomAction */4:
            var match$2 = match._0;
            var name = match$2.name;
            var code = match$2.code;
            link = {
              TAG: /* InternalLink */0,
              _0: function (e) {
                CustomScript$Showside.triggerCustomFunctionWithoutProducts(code, name, undefined, undefined);
              }
            };
            break;
        }
      } else {
        link = /* NoLink */0;
      }
      return {
        category: category,
        parent: root !== undefined && root.id !== category.id ? root : undefined,
        isHidden: !category.visibleInMenuBar || Belt_Option.mapWithDefault(parent, false, function (p) {
          return !p.visibleInMenuBar;
        }),
        isNested: root !== undefined && root.id !== category.id ? isNested(category) : false,
        isIndex: category.id === "index",
        isParentItself: Belt_Option.mapWithDefault(root, false, function (r) {
          return r.id === category.id;
        }),
        link: link
      };
    }), function (items) {
      return items.length !== 0;
    });
  }, [categories]);
}
export { noneIfEmpty, useItems };
/* react Not a pure module */